import * as React from 'react';
import Box from '@mui/material/Box';
import { NumberField } from '@base-ui/react/number-field';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import OutlinedInput from '@mui/material/OutlinedInput';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@base-ui/react/number-field": { NumberField }, "@mui/material/Button": Button, "@mui/material/FormControl": FormControl, "@mui/material/FormLabel": FormLabel, "@mui/icons-material/Add": AddIcon, "@mui/icons-material/Remove": RemoveIcon, "@mui/material/OutlinedInput": OutlinedInput, "@mui/icons-material/OpenInFull": OpenInFullIcon } } });
export default ClientProvider;
